import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, PRODUCT, TICKER_ITEMS } from '../data/woodworking';
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const half = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden bg-ember" data-id="element-126" data-mp="1vz47j6092way">
        <p className="sr-only" data-id="element-127" data-mp="29xbworr1otbk">{TICKER_ITEMS.join(' • ')}</p>
        <div className="animate-marquee flex h-[26px] w-max items-center sm:h-[30px]" aria-hidden data-id="element-128" data-mp="25v7661vw8ct5">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap text-[11px] font-bold leading-none uppercase tracking-[0.16em] text-white" data-id="element-129" data-mp="3laeic180492l" data-mpi={index}>
              {item}
              <span className="mx-7 h-1 w-1 rounded-full bg-brass-light sm:mx-9" data-id="element-130" data-mp="1bvh7xptkn1bg" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-white/10 bg-charcoal/95 backdrop-blur' : 'border-white/5 bg-charcoal'}`} data-id="element-131" data-mp="1gx6lpd86ht38">
        <div className="mx-auto flex h-[56px] w-full max-w-6xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-132" data-mp="1ptxn855i2057">
          <a href="#top" className="flex min-h-[44px] min-w-0 items-center" aria-label={`${PRODUCT.name} — back to top`} data-id="element-133" data-mp="x7cm4cz829og">
            <span className="wordmark text-left text-[clamp(0.9rem,4.2vw,1.05rem)] leading-tight text-white" data-id="element-134" data-mp="125xmqdidyvdf">
              Welding Projects That Sell<sup className="ml-0.5 font-sans text-[0.55em] font-semibold" data-id="element-135" data-mp="16yqt15ti6brm">™</sup>
            </span>
          </a>
          <nav aria-label="Sections" className="hidden items-center gap-6 lg:flex" data-id="element-136" data-mp="9hidy8pul9aj">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[0.86rem] font-semibold text-parchment hover:text-brass-light" data-id="element-137" data-mp="1hrsjhdov3kiw">
                {link.label}
              </a>)}
          </nav>
          <a href={OFFER_ANCHOR} className="hidden min-h-[42px] items-center whitespace-nowrap rounded-[8px] bg-ember px-4 text-[0.8rem] font-bold uppercase tracking-[0.06em] text-white hover:bg-ember-deep sm:inline-flex" data-id="element-138" data-mp="1qkcbvwek8sva">
            Get the Plans
          </a>
        </div>
      </header>
    </>;
}